// extracted by mini-css-extract-plugin
module.exports = {"Container":"Checkbox_Container__2p9VP","Checked":"Checkbox_Checked__20IZi"};